module.exports = __webpack_public_path__ + "static/media/39.b1f6ca1b.png";